import { render, staticRenderFns } from "./PCaseCardsBase.vue?vue&type=template&id=2271c3fe&scoped=true&"
import script from "./PCaseCardsBase.vue?vue&type=script&lang=js&"
export * from "./PCaseCardsBase.vue?vue&type=script&lang=js&"
import style0 from "./PCaseCardsBase.vue?vue&type=style&index=0&id=2271c3fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271c3fe",
  null
  
)

export default component.exports